// extracted by mini-css-extract-plugin
export default {"root":"MobileAttachesPage__root--YIY5a"};